import api from './axios'
import { authHeader } from '../helpers'
import { authService } from './authentication.service'

export const utilisateursService = {
    getByUtam,
    getInfosLecteurSurveillance
}

export function getByUtam(utam) {
    return api.get(`/Utilisateur/utam/${utam}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}

export function getInfosLecteurSurveillance(userId) {
    return api.get(`/Role/GetLecteurDonneesSurveillance/${userId}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse)
}
